import React, { useEffect, useState } from "react";
import "./SayHi.css";

function SayHi() {
  const [navHeight, setNavHeight] = useState(0);

  useEffect(() => {
    const updateNavHeight = () => {
      setTimeout(() => {
        const navbar = document.querySelector(".navbar-container");
        if (navbar) {
          setNavHeight(navbar.offsetHeight);
        }
      }, 0); // Ensures styles are fully applied before measuring
    };

    updateNavHeight(); // Initial measurement
    window.addEventListener("resize", updateNavHeight);

    return () => window.removeEventListener("resize", updateNavHeight);
  }, []);

  return (
    <div
      className="sayhi-container"
      style={{ height: `calc(100vh - ${navHeight + 10}px)` }}
    >
      <div className="desktop-sayhi-image">
        <img
          className="coloredline"
          src="/images/homepageimageline.svg"
          alt="Colored Line"
        />
        <img
          className="noncolored"
          src="/images/homepagemobile.svg"
          alt="Non-Colored Design"
        />
      </div>
      <div className="mobilesayhi-image">
        <img
          className="mobile-line-image"
          src="/images/homepagemobile.svg"
          alt="Design"
        />
      </div>
      <div className="sayhi-content">
        <a href="mailto:suzanne@cachoeira.me">SAY HI!</a>
        <div className="social-icons">
          <a
            href="https://www.instagram.com/wearecachoeira/"
            className="instagram"
          >
            <img src="/images/insta-gray.svg" alt="Instagram" />
          </a>
          <a href="mailto:suzanne@cachoeira.me" className="mail">
            <img src="/images/mail-grey.svg" alt="Email" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default SayHi;
